export const IS_DEV_MODE = false;
export const API_URL = 'https://qa.burnettindex.com/api';
export const SENTRY_DSN =
  'https://8565fa0c1bacd1d7b0deab554231c960@o4505908613218304.ingest.sentry.io/4505996344754176';
export const SENTRY_TRACES_SAMPLE_RATE = 0.5;
export const ENVIRONMENT = 'qa';
export const MUI_LICENSE_KEY =
  'b4ed3840263821e71cc15ee19155f982Tz0xMDU4NTUsRT0xNzY4MzQ4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';
